import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const UPDATE_PICOS_PRIORITY = gql`
  mutation UpdatePicOSPriority($input: UpdatePicOSPriorityInput!) {
    updatePicosPriority(input: $input) {
      picosPriority {
        ...PicOSPriority
      }
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
